// src/Models/clientQuestionModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class ClientQuestionModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      questionID: data.questionId || data.questionID,
      projectID: data.projectId || data.projectID,
      questionText: data.questionText,
      isMandatoryFlag: data.isMandatoryFlag !== undefined ? data.isMandatoryFlag : true,
      sequenceOrder: data.sequenceOrder || 0,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      questionId: Number(data.questionID || data.questionId || 0),
      projectId: Number(data.projectID || data.projectId || 0),
      questionText: data.questionText || '',
      isMandatoryFlag: data.isMandatoryFlag === true || data.isMandatoryFlag === 'true' || data.isMandatoryFlag === 1,
      sequenceOrder: Number(data.sequenceOrder || 0),
    };
  }
}
